class Team extends Utilities {

	// ===========================================================================
	// Constructor
	// ===========================================================================

	constructor(element) {

		super()

		let modal = new Modal()

		element.parentNode.classList.add('loading')
		let html = element.cloneNode(true)

    let settings = {
      template : '_components/modals/template.twig',
      type     : 'team'
    }

    fetcher.get('/fetch-template', settings, {

      success : (response) => {
				let wrapper = document.createElement('div');
				wrapper.innerHTML= response.html;
				let markup = wrapper.firstChild;
				markup.querySelector('modal-container').append(html)
        modal.open(markup, () => {
					element.parentNode.classList.remove('loading')
				})
      },
      error : (response) => {
        console.log('ERROR', response);
      }
    })
	}

}
